(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

const storageKey = "SEARCH_ENGINE";

const set = (key, value) => {
  const oldState = JSON.parse(localStorage.getItem(storageKey)) || {};
  localStorage.setItem(storageKey, JSON.stringify({ ...oldState,
    [key]: value
  }));
};

const get = key => {
  const state = JSON.parse(localStorage.getItem(storageKey)) || {};
  return state[key];
};

const remove = key => {
  const state = JSON.parse(localStorage.getItem(storageKey)) || {};
  const {
    [key]: deletedValue,
    ...newState
  } = state;
  localStorage.setItem(storageKey, JSON.stringify(newState));
};

const _default = {
  set,
  get,
  remove
};
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(storageKey, "storageKey", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/store/localStorage/storage.js");
  reactHotLoader.register(set, "set", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/store/localStorage/storage.js");
  reactHotLoader.register(get, "get", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/store/localStorage/storage.js");
  reactHotLoader.register(remove, "remove", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/store/localStorage/storage.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/store/localStorage/storage.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();